import { useState, useEffect } from "react";
import { ApiAuth } from "../../../core/apis";
import { ApiSchemaSuperAdmin } from "../../../models/api/apiSchemaSuperAdmin";
import { useAppSelector } from "../../../core/redux/reduxStore";

type ProfileTableProps = {
  data?: ApiSchemaSuperAdmin;
};
export const ProfileTable = (props: ProfileTableProps) => {
  const { role } = useAppSelector((state) => state.auth);
  const { data } = props;
  return (
    <>
      <table className="table">
        <tbody>
          <tr>
            <td>Full Name</td>
            <td className="table-data">{data?.FullName}</td>
          </tr>
          <tr>
            <td>Email</td>
            <td className="table-data">{data?.Email}</td>
          </tr>
          <tr>
            <td>Company Name</td>
            <td className="table-data">{data?.CompanyName}</td>
          </tr>
          {/* <tr>
            <td>Date of Birth</td>
            <td className="table-data"></td>
          </tr> */}
          {/* <tr>
            <td>Job Title</td>
            <td className="table-data">{data?.JobTitle}</td>
          </tr> */}
          {role?.toLowerCase() === "user" ? (
            <>
              {" "}
              <tr>
                <td>Phone Number</td>
                <td className="table-data">{data?.PhoneNumber}</td>
              </tr>
              <tr>
                <td>Type Of Company</td>
                <td className="table-data">{data?.TypeOfCompany}</td>
              </tr>{" "}
            </>
          ) : (
            <>
              <tr>
                <td>Address</td>
                <td className="table-data">{data?.Address}</td>
              </tr>
              <tr>
                <td>State</td>
                <td className="table-data">{data?.State}</td>
              </tr>
              <tr>
                <td>Country</td>
                <td className="table-data">{data?.CountryName}</td>
              </tr>
            </>
          )}
        </tbody>
      </table>
    </>
  );
};
